<!-- Background Image -->
<img class="absolute bottom-0 left-0 z-0 w-full h-auto"
     src="/assets/images/samples.png" alt="Samples background">

<app-retailer-top-bar class="relative"></app-retailer-top-bar>

<!-- Foreground Content -->
<div class="flex justify-center my-16 z-10 relative">
    <h1 class="text-5xl text-gray-800 dark:text-gray-100 text-center">Welcome to your SampleStudio!</h1>
</div>

<div class="flex justify-center gap-5 z-10 relative">
    <!-- Manage Samples -->
    <a
            href="/retailer/manage-samples"
            class="link-box relative transform transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg cursor-pointer"
            style="
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)), url('/assets/images/manage_samples.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    "
    >
        <div class="absolute bottom-0 p-2 h-24">
            <p class="text-white">Manage your sample studios</p>
            <p class="text-light-gray text-xs">Check the status of your samples or configure new samples</p>
        </div>
    </a>

    <!-- Customer Engagement -->
    <a
            href="/retailer/select-vehicle-model"
            class="link-box relative transform transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg cursor-pointer"
            style="
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)), url('/assets/images/customer_engagement.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    "
    >
        <div class="absolute bottom-0 p-2 h-24">
            <p class="text-white">Customer Engagement</p>
            <p class="text-light-gray text-xs">Interact with your customers and trigger valuable sample content on the
                digital:signage screen.</p>
        </div>
    </a>

    <!-- Order Samples -->
    <a
            href="https://digital-elements.rcps.mercedes-benz.com/shop"
            target="_blank"
            class="link-box relative transform transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg cursor-pointer"
            style="
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)), url('/assets/images/order_samples.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    "
    >
        <div class="absolute bottom-0 p-2 h-24">
            <p class="text-white">Order Samples</p>
            <p class="text-light-gray text-xs">Order samples for your sample studios easily.</p>
        </div>
    </a>
</div>


<!-- Bottom Center Action Buttons -->
<div class="fixed bottom-6 left-1/2 -translate-x-1/2 transform z-20">
    <div class="flex items-center gap-4">

        <!-- Lights On -->
        <button
                class="px-4 py-3 rounded-full border border-gray-400 dark:border-gray-600
             text-gray-800 dark:text-gray-200 bg-transparent
             hover:bg-gray-100 dark:hover:bg-gray-700
             shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed
             flex items-center gap-2"
                (click)="lightsOnAll()"
                [disabled]="turningLightsOn || turningLightsOff"
                [attr.aria-busy]="turningLightsOn"
                title="Turn all lights on"
                pTooltip="Turn all sample lights on"
                tooltipPosition="top"
                aria-label="Turn all lights on"
        >
            @if (!turningLightsOn) {
                <!-- Bulb On Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-6 w-6">
                    <path fill="currentColor"
                          d="M12 2a7 7 0 0 0-7 7c0 2.07.9 3.7 2.08 4.82.97.93 1.92 2 1.92 3.18V18h6v-.99c0-1.18.95-2.25 1.92-3.18A6.97 6.97 0 0 0 19 9a7 7 0 0 0-7-7Zm-3 19h6v1H9v-1z"/>
                </svg>
                <span class="font-medium">All lights on</span>
            } @else {
                <!-- Spinner -->
                <svg class="h-6 w-6 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4A4 4 0 008 12H4z"></path>
                </svg>
                <span class="font-medium">Turning on…</span>
            }
        </button>

        <!-- Lights Off -->
        <button
                class="px-4 py-3 rounded-full border border-gray-400 dark:border-gray-600
             text-gray-800 dark:text-gray-200 bg-transparent
             hover:bg-gray-100 dark:hover:bg-gray-700
             shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed
             flex items-center gap-2"
                (click)="lightsOffAll()"
                [disabled]="turningLightsOn || turningLightsOff"
                [attr.aria-busy]="turningLightsOff"
                title="Turn all lights off"
                pTooltip="Turn all sample lights off"
                tooltipPosition="top"
                aria-label="Turn all lights off"
        >
            @if (!turningLightsOff) {
                <!-- Bulb Off Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-6 w-6">
                    <path fill="currentColor"
                          d="M12 2C8.13 2 5 5.13 5 9c0 1.77.77 3.37 2 4.47V15a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1.53A6.978 6.978 0 0 0 19 9c0-3.87-3.13-7-7-7Zm-1 18h2v2h-2v-2z"/>
                    <line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" stroke-width="1.5"
                          stroke-linecap="round"/>
                </svg>
                <span class="font-medium">All lights off</span>
            } @else {
                <!-- Spinner -->
                <svg class="h-6 w-6 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4A4 4 0 008 12H4z"></path>
                </svg>
                <span class="font-medium">Turning off…</span>
            }
        </button>

    </div>
</div>

